import { useState, useEffect } from "react";
import { useQuery } from "react-query";

import { TAPIResponse } from "../types";
import { EnumExportOrderToPOSSyncStatuses, TExportOrderToPOSStatusResponse } from "./export-order-to-pos-status.types";
import { fetchExportOrderToPosStatus } from "./fetch-export-order-to-pos-status";
import { API_NAMES } from "../constants";

type TParams = {
    orderId: string;
    lsidIdentity: any;
    account_type: string;
    refetchInterval?: number;
};

type TResponse<Data, Error> = TAPIResponse<Data, Error> & {
    fetchOrderPOSSync: () => void;
};

export const useAPIFetchExportOrderToPOSStatus = ({
    refetchInterval = 1000,
    ...params
}: TParams): TResponse<TExportOrderToPOSStatusResponse, any> => {
    const [isLoading, setIsLoading] = useState(false);
    const startPolling = () => setIsLoading(true);

    const { data, error, isFetched } = useQuery<TExportOrderToPOSStatusResponse>(
        [API_NAMES.GET_ORDER_POS_SYNC, params.orderId],
        () =>
            fetchExportOrderToPosStatus({
                orderId: params.orderId,
                lsidIdentity: params.lsidIdentity,
                account_type: params.account_type,
            }),
        {
            enabled: isLoading,
            refetchInterval,
        },
    );

    const loaded =
        isFetched &&
        data &&
        [EnumExportOrderToPOSSyncStatuses.success, EnumExportOrderToPOSSyncStatuses.failure].includes(data.status);

    useEffect(() => {
        if (loaded || error) {
            setIsLoading(false);
        }
    }, [loaded, error]);

    return {
        data,
        error: data ? null : error,
        loaded,
        isLoading,
        fetchOrderPOSSync: startPolling,
    };
};
